import { render, staticRenderFns } from "./ItemMediaSwiper.vue?vue&type=template&id=738501a6&scoped=true&"
import script from "./ItemMediaSwiper.vue?vue&type=script&lang=js&"
export * from "./ItemMediaSwiper.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ItemMediaSwiper.vue?vue&type=style&index=0&id=738501a6&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "738501a6",
  "a73b19b4"
  
)

export default component.exports